import { useState } from 'react';
import { hot } from 'react-hot-loader';
import { Visibility } from 'semantic-ui-react';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScreenFirst from '../screens/ScreenFirst';
import ScreenWelcome from '../screens/ScreenWelcome';
import ScreenOwn from '../screens/ScreenOwn';
import ScreenBenefits from '../screens/ScreenBenefits';
import ScreenRoadmap from '../screens/ScreenRoadmap';
import ScreenTeam from '../screens/ScreenTeam';



function HomePage(props) {
  const [state, setState] = useState({ fixed: false });
  const hideFixedMenu = () => setState({ fixed: false });
  const showFixedMenu = () => setState({ fixed: true });
  return (
    <Seo meta={[]}>
      <Visibility
        once={false}
        onBottomPassed={showFixedMenu}
        onBottomPassedReverse={hideFixedMenu}
      >
        <Header fixed={state.fixed} />
        <ScreenFirst />
      </Visibility>
      <ScreenWelcome />
      {/*<ScreenOwn />
      <ScreenBenefits />
      <ScreenRoadmap />
      <ScreenTeam />*/}
      <Footer />
    </Seo>
  );
};

export default hot(module)(HomePage);
